// Fetch monument portfolios from our backend

import http from "./http-common";

interface Organization {
  id: string;
  name: string;
}

export class MonumentService {
  static getOrganizations() {
    return http.get<Organization[]>("monument/get-organizations");
  }
}
